import { render, staticRenderFns } from "./ViewTaxCode.vue?vue&type=template&id=763053d8&scoped=true"
import script from "./ViewTaxCode.vue?vue&type=script&lang=js"
export * from "./ViewTaxCode.vue?vue&type=script&lang=js"
import style0 from "./ViewTaxCode.vue?vue&type=style&index=0&id=763053d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763053d8",
  null
  
)

export default component.exports